var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-wrap"},[_c('ul',_vm._l((_vm.steps),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(item.time))]),_c('div',{staticClass:"circle"}),_c('span',{staticClass:"message",domProps:{"innerHTML":_vm._s(item.context)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }